import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/repeat-03.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 11.9999C21 9.75762 19.7701 7.80072 17.9443 6.77043L17.5713 6.57707L17.4805 6.52824C17.0471 6.26556 16.8745 5.71166 17.0967 5.24407C17.319 4.77644 17.8575 4.56098 18.335 4.73137L18.4287 4.77043L18.6797 4.89446C21.2447 6.22527 23 8.90679 23 11.9999C23 16.4182 19.4183 19.9999 15 19.9999H12.4141L13.707 21.2929L13.7754 21.3691C14.0957 21.7618 14.0731 22.3408 13.707 22.707C13.3409 23.0731 12.7619 23.0957 12.3691 22.7753L12.293 22.707L9.29297 19.707C8.90244 19.3164 8.90244 18.6834 9.29297 18.2929L12.293 15.2929C12.6835 14.9024 13.3165 14.9024 13.707 15.2929C14.0976 15.6834 14.0976 16.3164 13.707 16.707L12.4141 17.9999H15C18.3137 17.9999 21 15.3136 21 11.9999ZM1 11.9999C1 7.58165 4.58172 3.99992 9 3.99992H11.5859L10.293 2.70696L10.2246 2.63078C9.90426 2.23801 9.92685 1.65901 10.293 1.29289C10.6835 0.902369 11.3165 0.902369 11.707 1.29289L14.707 4.29289C15.0976 4.68342 15.0976 5.31643 14.707 5.70696L11.707 8.70696C11.3165 9.09748 10.6835 9.09748 10.293 8.70696C9.90244 8.31643 9.90244 7.68342 10.293 7.29289L11.5859 5.99992H9C5.68629 5.99992 3 8.68622 3 11.9999C3 14.3917 4.39951 16.4586 6.42871 17.4228C6.92757 17.6598 7.1403 18.2569 6.90332 18.7558C6.68099 19.2234 6.1425 19.4389 5.66504 19.2685L5.57129 19.2294L5.32031 19.1054C2.75534 17.7746 1 15.0931 1 11.9999Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Repeat03Icon };
